import React from 'react';

import {
  LoadingOverlay,
  Spinner
} from './styles';

const LoadingIndicator = () => {
  return (
    <LoadingOverlay>
      <Spinner />
    </LoadingOverlay>
  );
};

export default LoadingIndicator;